import {
  CButton,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CSpinner,
} from '@coreui/react';
import TableCaption from './TableCaption';
import TableFooter from './TableFooter'; // Reutilizar el footer existente
import styles from './Table.module.css';

const QrTagBatchTable = ({ columns, data, pagination, onPageChange, onDownload }) => {
  return (
    <>
      <div className="col-12">
      <TableCaption pagination={pagination} noun="lotes" />
      <div className={styles.tableCard}>
      <CTable responsive className={styles.styledTable}>
        <CTableHead>
          <CTableRow>
            {columns.map((col, index) => (
              <CTableHeaderCell key={index} {...col._props}>
                {col.label}
              </CTableHeaderCell>
            ))}
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {data.length === 0 ? (
            <CTableRow>
              <CTableDataCell colSpan={columns.length} className="text-center py-4 text-muted">
                No se encontraron lotes con los filtros seleccionados.
              </CTableDataCell>
            </CTableRow>
          ) : (
            data.map((batch, index) => (
              <CTableRow key={batch.id || index}>
                <CTableDataCell>{batch.id}</CTableDataCell>
                <CTableDataCell>{batch.company_name}</CTableDataCell>
                <CTableDataCell>{batch.qr_tag_batch_status}</CTableDataCell>
                <CTableDataCell>{batch.owner_name}</CTableDataCell>
                <CTableDataCell>{batch.email}</CTableDataCell>
                <CTableDataCell>{batch.badge_size_name}</CTableDataCell>
                <CTableDataCell className="text-center">{batch.qr_tags_amount}</CTableDataCell>
                <CTableDataCell>{batch.created_at}</CTableDataCell>
                
                {/* Acciones */}
                <CTableDataCell>
                  <div className="d-flex gap-2">
                    <CButton 
                      color="info" 
                      size="sm" 
                      variant="outline"
                      onClick={() => window.location.href = batch.actions.view}
                      title="Ver detalle"
                    >
                      👁️
                    </CButton>
                    
                    <CButton 
                      color="warning" 
                      size="sm" 
                      variant="outline"
                      onClick={() => window.location.href = batch.actions.edit}
                      title="Editar"
                    >
                      ✏️
                    </CButton>
                    
                    {batch.actions.hasQrTags ? (
                      <CButton 
                        color="success" 
                        size="sm"
                        onClick={() => onDownload?.(batch.id, batch.company_name)}
                        title="Descargar hoja de QRs"
                        disabled={false} // El overlay se encarga de deshabilitar
                      >
                        📄
                      </CButton>
                    ) : (
                      <CButton 
                        color="secondary" 
                        size="sm"
                        disabled
                        title="Sin QRs para descargar"
                      >
                        📄
                      </CButton>
                    )}
                  </div>
                </CTableDataCell>
              </CTableRow>
            ))
          )}
        </CTableBody>
      </CTable>
      </div>
      </div>
      
      {/* Footer con paginación */}
      {pagination && (
        <TableFooter 
          range={pagination.links} 
          setPageUrl={onPageChange}
          currentPage={pagination.current_page}
          totalPages={pagination.last_page}
        />
      )}
    </>
  );
};

export default QrTagBatchTable;